import { FC } from 'react';
import { Typography } from '@mui/material';
import { FieldRow } from 'components/FormElements';
import {
  AntiDilutionLabels,
  LiquidationPreferenceLabels,
  MonitoringRightsLabels,
} from 'further-ui/labels';
import {
  AntiDilutionRights,
  CouponType,
  LiquidationPreferenceType,
  MonitoringRights,
} from 'further-types/lp/holding-class';
import { CurrencyCode } from 'further-types/lp/vehicle';
import { Column } from 'further-ui/components/Layout';

export type HoldingClassDetails = {
  _id: string;
  name: string;
  currency: CurrencyCode;
  monitoringRights?: MonitoringRights;
  liquidationPreferenceType?: LiquidationPreferenceType;
  liquidationPreferenceMultiple?: number;
  antiDilutionRights?: AntiDilutionRights;
  couponRights?: CouponType;
  couponAmount?: number | null;
};

type ClassHoldingsInfoProps = {
  holdingClass: HoldingClassDetails;
};

const ClassHoldingsInfo: FC<ClassHoldingsInfoProps> = ({ holdingClass }) => {
  return (
    <Column spacing="md">
      <FieldRow title="Class name">
        <Typography variant="body2" color="grey.900">
          {holdingClass.name}
        </Typography>
      </FieldRow>
      <FieldRow title="Currency">
        <Typography variant="body2" color="grey.900">
          {holdingClass.currency}
        </Typography>
      </FieldRow>
      <FieldRow title="Monitoring rights">
        <Typography variant="body2" color="grey.900">
          {
            MonitoringRightsLabels[
              holdingClass.monitoringRights || MonitoringRights.None
            ]
          }
        </Typography>
      </FieldRow>
      <FieldRow title="Liquidation preference type">
        <Typography variant="body2" color="grey.900">
          {
            LiquidationPreferenceLabels[
              holdingClass.liquidationPreferenceType ||
                LiquidationPreferenceType.None
            ]
          }
        </Typography>
      </FieldRow>
      <FieldRow title="Liquidation preference multiple">
        <Typography variant="body2" color="grey.900">
          {holdingClass.liquidationPreferenceMultiple
            ? `${holdingClass.liquidationPreferenceMultiple}x`
            : 'None'}
        </Typography>
      </FieldRow>
      <FieldRow title="Anti-dilution rights">
        <Typography variant="body2" color="grey.900">
          {
            AntiDilutionLabels[
              holdingClass.antiDilutionRights || AntiDilutionRights.None
            ]
          }
        </Typography>
      </FieldRow>
      <FieldRow title="Coupon rights">
        <Typography variant="body2" color="grey.900">
          {holdingClass.couponRights || 'None'}
        </Typography>
      </FieldRow>
      <FieldRow title="Coupon amount (per annum)">
        <Typography variant="body2" color="grey.900">
          {holdingClass.couponAmount ? `${holdingClass.couponAmount}%` : 'None'}
        </Typography>
      </FieldRow>
    </Column>
  );
};

export default ClassHoldingsInfo;
